import React from 'react';
import cn from 'classnames';
import { Popover, PopoverProps } from '../Popover/Popover';
import './Hanger.css';
import { useGaudiLocalization } from '../Provider/Provider';
import { IconButton } from '../IconButton/IconButton';

export type HangerTexts = {
    /** Aria-label for the close icon button of hanger */
    close: string;
};

export type CloseHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void | undefined;

export type HangerProps = PopoverProps & {
    /** Handler called when user closes the hanger */
    onClose?: CloseHandler;
};

export const Hanger = React.forwardRef((props: HangerProps, ref: React.Ref<HTMLDivElement>) => {
    const { children, onClose: handleClose, placement = 'bottom', visible = true, ...otherProps } = props;
    const { texts } = useGaudiLocalization();

    const closeHanger = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, hide: () => void): void => {
        hide();

        if (handleClose) {
            handleClose(event);
        }
    };

    const className = cn('yt-hanger', props.className);

    return (
        <Popover
            {...otherProps}
            className={className}
            disableOpenOnClick
            hideOnClickOutside={false}
            modal={false}
            placement={placement}
            ref={ref}
            visible={visible}>
            {({ hide }) => (
                <>
                    <IconButton
                        icon="close"
                        appearance="discrete"
                        aria-label={texts.hanger.close}
                        className="yt-hanger__close"
                        onClick={event => closeHanger(event, hide)}
                    />
                    {children}
                </>
            )}
        </Popover>
    );
});
